import { AreaFilesInformation } from "@mapmycustomers/shared/types/territory/AreaRegion";

const findFileInformationByZoomLevel = (
  zoom: number,
  files: AreaFilesInformation[]
): AreaFilesInformation | undefined => {
  let result: AreaFilesInformation | undefined;

  for (const fileInfo of files) {
    const { zoomLevelRange } = fileInfo;
    if (zoomLevelRange[0] === zoom && zoomLevelRange[1] === zoom) {
      return fileInfo; // best match, exact zoom level match
    }
    if (zoom >= zoomLevelRange[0] && zoom < zoomLevelRange[1]) {
      result = fileInfo; // 2nd best match, within the range (we don't care about range length)
    }
  }

  return result;
};

export default findFileInformationByZoomLevel;
